import {ShareClassViewModel} from './share-class.view-model';
import {inject, Injectable} from '@angular/core';
import {ShareClassDTO} from '@dto/entities/share-class-dto.model';
import {FormattedNumber} from '@components/ui/table-template/classes/formatted-number';
import {DateConverterService} from '@shared/services/date-converter.service';

@Injectable({
  providedIn: 'root'
})
export class ShareClassConverterService {
  private readonly dateConverterService = inject(DateConverterService);

  convert(shareClasses: ShareClassDTO[]): ShareClassViewModel[] {
    return shareClasses.map(sc => this.convertSingle(sc));
  }

  private convertSingle(shareClass: ShareClassDTO): ShareClassViewModel {

    if (shareClass.EffectiveDate === '0001-01-01') {
      shareClass.EffectiveDate = null;
    }

    if (Number.parseFloat(shareClass.ParValue) === 0) {
      shareClass.ParValue = 'Nil';
    }

    return {
      shareClassLineNo: shareClass.ShareClassLineNo,
      shareClass: shareClass.ShareClass,
      description: shareClass.Description,
      currencyCode: shareClass.CurrencyCode,
      shares: new FormattedNumber(shareClass.AuthorisedShares),
      nominalValue: new FormattedNumber(shareClass.ParValue),
      valueAuthorised: new FormattedNumber(shareClass.TotalValue),
      effectiveDate: (shareClass.EffectiveDate ? this.dateConverterService.toDate(shareClass.EffectiveDate) : null),
      sharesIssued: new FormattedNumber(shareClass.SharesIssued),
      sharesAvailable: new FormattedNumber(shareClass.SharesAvailable)
    };
  }
}
